import { render, staticRenderFns } from "./knowledge_graph.vue?vue&type=template&id=45a33d6a&scoped=true&"
import script from "./knowledge_graph.vue?vue&type=script&lang=js&"
export * from "./knowledge_graph.vue?vue&type=script&lang=js&"
import style0 from "./knowledge_graph.vue?vue&type=style&index=0&id=45a33d6a&prod&lang=less&scoped=true&"
import style1 from "./knowledge_graph.vue?vue&type=style&index=1&id=45a33d6a&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a33d6a",
  null
  
)

export default component.exports